import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { formatIndianPrice } from "../../formatIndianPrice";

const ReactLineChart = ({ data }) => {
  if (!data || !data.chart || !data.chart.data) {
    return <div className="d-flex justify-content-center align-items-center" style={{height:'100%',fontWeight:'500',fontSize:'24px',color:'#391f84'}}>No Data Found</div>;
  }

  const chartData = data.chart.data.labels.map((label, index) => {
    const month = label.split(" ")[0];
    return {
      name: month,
      value: data.chart.data.datasets[0].values[index] || 0
    };
  });

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "6px",
          padding: "8px 12px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          fontSize: "12px",
        }}
      >
        <p style={{ margin: 0, fontWeight: "bold", color: "#391f84" }}>
          {label}
        </p>
        <p style={{ margin: 0, color: "#823455" }}>
          ₹{formatIndianPrice(payload[0].value)}
        </p>
      </div>
    );
  }
  return null;
};


  const formatYAxisTick = (value) => {
    return `${value / 10000000} Cr`;
  };

  return (
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <defs>
            <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#823455" stopOpacity={0.4} />
              <stop offset="100%" stopColor="#823455" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#391f84" }} />
<YAxis tickFormatter={formatYAxisTick} tick={{ fontSize: 12, fill: "#391f84" }} />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#823455"
            fill="url(#colorSales)"
            strokeWidth={2}
            dot={{ r: 3, strokeWidth: 2, fill: "#823455" }}
          />
        </AreaChart>
      </ResponsiveContainer>
  );
};

export default ReactLineChart;
